<template>
    <v-container fluid>
        <v-main>
            <v-row>
                <v-col md="3">
                    <brick_1
                        color="red"
                        :loading="isLoading"
                        :data="bricks.brick_1"
                        :curr="curr"
                        @reload="reload"
                    ></brick_1>
                </v-col>
                <v-col md="3">
                    <brick_2
                        color="red"
                        :loading="isLoading"
                        :data="bricks.brick_2"
                        :curr="curr"
                        @reload="reload"
                    ></brick_2>
                </v-col>
                <v-col md="3">
                    <brick
                        caption="Reminders to send"
                        subtitle="re-send invoices"
                        :count="count_3"
                        color="red"
                        :loading="isLoading"
                    ></brick>
                </v-col>
                <v-col md="3">
                    <brick
                        caption="Report payments"
                        subtitle="received payments today"
                        :count="count_4"
                        color="green"
                        :loading="isLoading"
                    ></brick>
                </v-col>
            </v-row>
        </v-main>
    </v-container>
</template>

<script>

import {mapGetters} from 'vuex'
import brick from '../../../components/Bricks/small'
import brick_1 from "./brick_1"
import brick_2 from "./brick_2"
import api from '../_api'

export default {
    name: "todo_bricks",

    components: {
        brick,
        brick_1,
        brick_2
    },

    data: () => ({
        bricks: {
            brick_1: {},
            brick_2: {},
            brick_3: {},
            brick_4: {}
        },
        count_2: null,
        count_3: null,
        count_4: null,
        isLoading: true,
    }),

    computed: {
        ...mapGetters({
            country: 'countries/activeCountryId',
            curr: 'countries/activeCountryCurr'
        }),
    },

    watch: {
        country() {
            this.bricks = {
                brick_1: {},
                brick_2: {}
            },
                this.reload()
        }

    },

    methods: {
        reload() {
            this.isLoading = true;
            api.fetchToDoBricks(this.country)
                .then(response => {
                    this.bricks.brick_1 = response.data.readyToSetReleaseDate;
                    this.bricks.brick_2 = response.data.readyToFirstSend;
                    this.count_3 = response.data.readyToRemindersSend.ready_count;
                    this.count_4 = response.data.paidToday.count;

                    this.isLoading = false;
                })
                .catch(error => {
                    console.log(error)
                })
        }
    },

    created() {
        this.reload(this.country)
    },

    mounted() {

    }
}
</script>

<style scoped>

</style>
